import keysIn_default from "./keysIn.js";
import _getSymbolsIn_default from "./_getSymbolsIn.js";
import _baseGetAllKeys_default from "./_baseGetAllKeys.js";

//#region ../../node_modules/lodash-es/_getAllKeysIn.js
/**
* Creates an array of own and inherited enumerable property names and
* symbols of `object`.
*
* @private
* @param {Object} object The object to query.
* @returns {Array} Returns the array of property names and symbols.
*/
function getAllKeysIn(object) {
	return _baseGetAllKeys_default(object, keysIn_default, _getSymbolsIn_default);
}
var _getAllKeysIn_default = getAllKeysIn;

//#endregion
export { _getAllKeysIn_default as default };
//# sourceMappingURL=_getAllKeysIn.js.map